<template>
  <v-dialog v-model="dialog" max-width="1200px" scrollable>
    <v-card v-if="query" class="rdrive-duckdb-query-dialog__card">
      <v-card-title class="text-h5 d-flex align-center">
        <v-icon class="me-2">mdi-database</v-icon>
        {{ t('title') }}
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          variant="outlined"
          size="small"
          class="me-2"
          @click="emit('export')"
          :loading="exporting"
        >
          <v-icon class="me-1">mdi-database-export</v-icon>
          {{ t('exportToZip') }}
        </v-btn>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-textarea
          v-model="sql"
          :label="t('sql')"
          rows="4"
          auto-grow
          hide-details
          variant="outlined"
          density="compact"
          spellcheck="false"
          class="rdrive-duckdb-query-dialog__input mb-2"
          @keydown.ctrl.enter="runQuery"
          @keydown.meta.enter="runQuery"
        />

        <div class="d-flex align-center ga-2 mb-3">
          <v-btn color="primary" size="small" :loading="running" @click="runQuery">
            <v-icon class="me-1">mdi-play</v-icon>
            {{ t('run') }}
          </v-btn>
          <span class="text-caption text-medium-emphasis">{{ t('runShortcut') }}</span>
          <v-spacer></v-spacer>
          <v-btn
            v-for="shortcut in query.shortcuts"
            :key="shortcut.label"
            size="x-small"
            variant="tonal"
            class="text-none"
            @click="sql = shortcut.sql"
          >
            {{ shortcut.label }}
          </v-btn>
        </div>

        <v-alert v-if="error || noRows" type="error" density="compact" variant="tonal" class="mb-3">
          {{ error || t('noRows') }}
        </v-alert>

        <div v-if="resultColumns.length > 0">
          <div class="text-caption text-medium-emphasis mb-1">
            {{ truncated ? t('rowsTruncated', { count: total, max: MAX_ROWS }) : t('rows', { count: total }) }}
          </div>
          <div class="rdrive-duckdb-query-dialog__result">
            <v-table density="compact" fixed-header height="360">
              <thead>
                <tr>
                  <th v-for="column in resultColumns" :key="column">{{ column }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in resultRows" :key="index">
                  <td v-for="column in resultColumns" :key="column">{{ formatCell(row[column]) }}</td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card v-else>
      <v-card-title class="text-h5 d-flex align-center">
        <v-icon class="me-2">mdi-database</v-icon>
        {{ t('title') }}
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          variant="outlined"
          size="small"
          class="me-2"
          @click="emit('export')"
          :loading="exporting"
        >
          <v-icon class="me-1">mdi-database-export</v-icon>
          {{ t('exportToZip') }}
        </v-btn>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script src="./model.js"></script>
<style src="./style.css"></style>
